<template>
  <div class="top-navbar">
    <div class="navbar-left">
      <div class="logo-container">
        <img
          :src="sentrykitWordmark"
          alt="SentryKit 2.0"
          class="navbar-wordmark"
        />
      </div>
    </div>
    <div v-if="$slots.filters" class="navbar-center">
      <slot name="filters"></slot>
    </div>
    <div class="navbar-right">
      <slot name="right">
        <div v-if="userEmail" class="navbar-account">
          <span class="navbar-user-email">{{ userEmail }}</span>
          <span class="navbar-account-sep" aria-hidden="true">|</span>
          <button type="button" class="navbar-logout" @click="signOut">Log out</button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import './styles/TopNavbar.css'
var brandAssets = require('../../utils/brandAssets.js')

export default {
  name: 'TopNavbar',
  data: function () {
    return {
      sentrykitWordmark: brandAssets.sentrykitWordmark
    }
  },
  props: {
    lastUpdated: {
      type: String,
      default: 'just now'
    },
    userEmail: {
      type: String,
      default: ''
    }
  },
  methods: {
    signOut: function () {
      if (this.$root.signOutUser) {
        this.$root.signOutUser()
      } else {
        this.$http.get('/api/auth/signout').then(function () { })
        document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        sessionStorage.removeItem('worldStore')
        this.$router.push('/login')
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// TopNavbar.vue?0b380aae